import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, getListIds, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetSalaryInfo, doSaveSalaryInfo, doDeleteSalaryInfo } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { doSalaryInfoAction } from '../../business/SalaryInfoAction'
import SetSalaryAdjustmentPersonDiv from './SetSalaryAdjustmentPersonDiv'
import BatchSetAmontDiv from './BatchSetAmontDiv'
import SalaryInfoAdjustDiv from './SalaryInfoAdjustDiv'
class SalaryInfoSettingDetail extends React.Component {
	state = {
		changedValues基本信息: {},
		bSave: false
	}

	componentDidMount = () => {
		this.doGetSalaryInfo(this.props.id)
	}
	componentWillUnmount = () => {
		this.unmount = true
	}
	doGetSalaryInfo = (id) => {
		const { dispatch, taskName } = this.props
		dispatch(doGetSalaryInfo({
			id: id || 0,
			taskName,
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ bSave: false })
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
				}
			}
		}))
	}

	handlerSave = () => {
		const { dispatch, onSave, onClose } = this.props
		const { id, changedValues基本信息, initValues基本信息, bSave } = this.state
		if (!bSave) {
			this.setState({ bSave: true })
			const { list: list薪资明细 } = Tyan.utility.getListItems(this, '基本信息', '薪资明细')
			dispatch(doSaveSalaryInfo({
				id,
				list薪资明细,
				changedValues基本信息,
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						this.setState({ bSave: false })
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('保存成功')
						this.setState({ id })
						this.doGetSalaryInfo(id)
					}
				}
			}))
		}
	}

	handlerDefaultejection = () => {
		const { optionsParas } = this.state
		const 显示列 = optionsParas['显示列']
		const ids = getListIds(this, '基本信息', '薪资明细')
		var listItemChangedValuesPar = []
		var obj = {}
		var obj1 = {}
		if (ids && 显示列) {
			显示列.map(p => {
				if (p.edit) {
					obj[`审批结果_${p.name}`] = '驳回'
					obj1[`审批结果_${p.name}`] = 'string'
				}
			})
			ids.forEach(o => {
				listItemChangedValuesPar.push(obj)
			})
			changeListItem(this, listItemChangedValuesPar, obj1, '基本信息', '薪资明细', ids)
		}
	}

	handlerDelete = () => {
		const { dispatch, onSave, onClose } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			dispatch(doDeleteSalaryInfo({
				id,
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('删除成功')
						onClose && onClose()
					}
				}
			})))
	}

	handelSubmit = (action, title) => {
		const { onSave, onClose, dispatch, showDetail } = this.props
		const { id } = this.state
		doSalaryInfoAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
	}

	handleChangeList = (v, id, name, fieldName, type) => {
		const listItemChangedValuesPar = { [name]: v }
		const listItemTypesOfchangedValuesPar = { [name]: type }
		changeListItem(this, listItemChangedValuesPar, listItemTypesOfchangedValuesPar, '薪资明细', fieldName, id)
	}

	handlerSetSalaryPerson = () => {
		const { id } = this.state
		Tyan.pubForm.showDialog('设置调薪人员', props => <SetSalaryAdjustmentPersonDiv {...props} id={id} onSave={() => this.doGetSalaryInfo(id)} />)
	}

	handlerBatchSet = () => {
		const { id } = this.state
		Tyan.pubForm.showDialog('批量设置', props => <BatchSetAmontDiv {...props} id={id} onSave={() => this.doGetSalaryInfo(id)} />)
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bSubmit = () => {
		const { initValues基本信息, changedValues基本信息, id } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return Object.keys(changedValues基本信息).length > 0
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	bSave = () => {
		const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return Object.keys(changedValues基本信息).length > 0 && values.生效月份
	}

	fieldset基本信息 = () => {
		const { initValues基本信息 } = this.state
		const { 状态 } = initValues基本信息
		return [
			{
				_group: '', minWidth: '95%', items: [
					{ _text: '申请编号', minWidth: '25%', disabled: true },
					{ _text: '申请人', minWidth: '25%', disabled: true },
					{ _date: '申请日期', minWidth: '25%', disabled: true },
					{ _select: '生效月份', minWidth: '25%', disabled: 状态 !== 1, required: true, editable: true, forceSelection: false },
					{ _text: '申请原因', minWidth: '90%', disabled: 状态 !== 1 },
				]
			},
		]
	}

	fieldset薪资明细 = () => {
		const { initValues基本信息, optionsParas, id } = this.state
		// const { 状态, 提交时间 } = initValues基本信息
		const 显示列 = optionsParas['显示列']
		//const { list } = Tyan.utility.getListItems(this, '基本信息', '薪资明细')
		return [
			{
				_grid: '', name: '薪资明细', height: '100%', lockable: true, /* minRows: list ? list.length : 1, */
				columns: [
					{ _text: '员工编号', flex: 1, minWidth: 100 },
					{ _text: '员工姓名', flex: 1, locked: true } //locked: 'right'|'left'|true(同left)
				].concat(显示列 && 显示列.map(o => {
					return {
						_float: o.showName, name: `金额_${o.name}`, flex: 1, minWidth: 150,
						format: o.name == '工伤保险公司扣款比例' ? '0,000.000' : '0,000.00',
						zeroValue: null, style: data => {
							const style = data['style_' + o.name] //getFormValue(this, '基本信息', `薪资明细[${data.id}].style_${o.name}`)
							return { color: style }
						},
						tooltip: data => {
							const remark = data['remark_' + o.name]//getFormValue(this, '基本信息', `薪资明细[${data.id}].remark_${o.name}`)
							return remark
						},
					}
				})),
				onDoubleTap: data => {
					Tyan.pubForm.showDialog('薪资设定', props => <SalaryInfoAdjustDiv {...props} id={id} personId={data.id} onSave={() => this.doGetSalaryInfo(id)} />)
				}
			}]
	}

	fieldset薪资明细1 = () => {
		const { initValues基本信息, optionsParas } = this.state
		const { 状态, 提交时间 } = initValues基本信息
		const 显示列 = optionsParas['显示列']
		const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
		const { list: 薪资明细 } = Tyan.utility.getListItems(this, '基本信息', '薪资明细')
		return 薪资明细 && 薪资明细.map(q => {
			const list = { listName: '薪资明细', id: q.id }
			return {
				_border: `${q.title}`, name: `薪资明细_${q.id}`, minWidth: '95%', margin: '15px 5px 5px 5px', items: [
					{
						_group: '', minWidth: '95%', items: [
							{ _label: '科目名称' }
						].concat(显示列 && 显示列.map(o => {
							return { _label: o.showName, name: o.name, disabled: true, ...p, align: 'right' }
						}))
					},
					{
						_group: '', minWidth: '95%', items: [
							{ _label: '金额' }
						].concat(显示列 && 显示列.map(n => {
							const value = getFormValue(this, '基本信息', `薪资明细[${q.id}].金额_${n.name}`)
							const 原值 = getFormValue(this, '基本信息', `薪资明细[${q.id}].原值_${n.name}`)
							const 是否修改 = getFormValue(this, '基本信息', `薪资明细[${q.id}].是否修改_${n.name}`)
							const bDisabled = getFormValue(this, '基本信息', `薪资明细[${q.id}].bDisabled_${n.name}`)
							return {
								_float: '', name: `金额_${n.name}`, list, ...p,
								disabled: bDisabled,
								tooltip: value == 原值 || 状态 == 1 ? '' : `原值：${原值}`,
								ui: 状态 == 2 ? (是否修改 == '是' ? 'red' : '') : (状态 == 3 ? (value == 原值 ? '' : 'red') : ''),
							}
						}))
					},
					{
						_group: '', minWidth: '95%', items: [
							{ _label: '备注' }
						].concat(显示列 && 显示列.map(n => {
							const bDisabled = getFormValue(this, '基本信息', `薪资明细[${q.id}].bDisabled_${n.name}`)
							return { _text: '', name: `备注_${n.name}`, list, maxRows: 3, ...p, /* disabled: true */ disabled: bDisabled }
						}))
					},
					{
						_group: '', minWidth: '95%', cdt: () => 状态 == 2, items: [
							{ _label: '审批结果' }
						].concat(显示列 && 显示列.map(n => {
							return { _select: '', name: `审批结果_${n.name}`, options: ['', '驳回'], list, ...p, disabled: 状态 !== 2 || !n.edit }
						}))
					},
					{
						_group: '', minWidth: '95%', cdt: () => (状态 == 1 && 提交时间 !== nullDate) || 状态 == 2, items: [
							{ _label: '审批备注' }
						].concat(显示列 && 显示列.map(n => {
							return { _text: '', name: `审批备注_${n.name}`, list, ...p, /* disabled: true */disabled: 状态 !== 2 || !n.edit }
						}))
					}
				]
			}
		}).concat([{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } },
		{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }
		])
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}


	render() {
		const { showMessage: Message, showBody: Body, readOnly } = this.props
		const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态, 状态名称, 提交时间, } = initValues基本信息
		const bSubmit = this.bSubmit()
		return <Body data={this}
			controls={
				readOnly ? [
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose }
				] : [
					{ _button: '设置调薪人员...', icon: 'share', handler: () => this.handlerSetSalaryPerson(), disabled: bSubmit, cdt: () => id > 0 && 状态名称 == '调薪申请' && 提交时间 == nullDate },
					{ _button: '批量设置...', icon: 'share', handler: () => this.handlerBatchSet(), disabled: bSubmit, cdt: () => id > 0 && 状态名称 == '调薪申请' },
					{ _flow: 'SalaryChangeApplyFlow', disabled: this.bSave(), cdt: () => id > 0, id: getFormValue(this, '基本信息', 'ArchivesID') },
					// { _button: '退回申请', icon: 'reply', ui: 'action decline alt', handler: () => this.handelSubmit(`${状态名称}.退回申请`, '退回申请'), cdt: () => id > 0 && 状态 == 2, disabled: bSubmit },
					// { _button: 状态名称 != '调薪申请' ? '确认' : '提交', icon: 'share', handler: () => this.handelSubmit(`${状态名称}.提交`, '提交'), cdt: () => id > 0 && 状态 !== 3, disabled: bSubmit },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: () => this.handlerDelete(), cdt: () => id > 0 && 状态 == 1 && 提交时间 == nullDate, disabled: bSubmit },
					//{ _button: '默认驳回', icon: 'share', handler: this.handlerDefaultejection, cdt: () => 状态名称 == '调薪审核' },
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), cdt: () => 状态名称 == '调薪申请' || 状态名称 == '调薪审核' },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '薪资设定', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', forceDisabled: 状态名称 == '调薪完成' || 状态名称 == '调薪批准' || readOnly },
					{
						_fieldsets: [
							{ title: '薪资明细', name: '基本信息', _fieldset: this.fieldset薪资明细(), fullblock: true, minWidth: '95%', forceDisabled: 状态名称 == '调薪完成' || 状态名称 == '调薪批准' || readOnly },
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
						]
					}
				]
			}
		/>
	}
}

export default connect()(SalaryInfoSettingDetail)